export type InBoxCompleteness = 'full' | 'partial' | 'phone_only'

export const IN_BOX_OPTIONS: InBoxCompleteness[] = ['full', 'partial', 'phone_only']

export const IN_BOX_KIT_COLORS: Record<InBoxCompleteness, string> = {
  full: '#10b981',
  partial: '#3b82f6',
  phone_only: '#ca8a04',
}

export function inBoxLabelKey(value: string | undefined | null): string {
  switch (value) {
    case 'full':
      return 'listing.kit.full'
    case 'partial':
      return 'listing.kit.partial'
    default:
      return 'listing.kit.phoneOnly'
  }
}

/** Map legacy/wrong filter values to canonical DB enum. */
export function normalizeInBoxFilter(value: string): string {
  switch (value) {
    case 'full_kit':
      return 'full'
    case 'charger_only':
      return 'partial'
    default:
      return value
  }
}
